import React, { useEffect, useRef } from 'react';
import {
  Box,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { motion } from 'framer-motion';

const MotionPaper = motion(Paper);

export const TradingViewNewsCalendar: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
    // Use setTimeout to ensure DOM is ready and avoid React strict mode issues
    const timer = setTimeout(() => {
      if (containerRef.current) {
        // Clear container completely
        containerRef.current.innerHTML = '';
        
        // Create script element
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
        script.async = true;
        script.innerHTML = JSON.stringify({
          width: "100%",
          height: isMobile ? "350" : "450",
          colorTheme: "dark",
          isTransparent: false,
          locale: "en",
          importanceFilter: "0,1",
          countryFilter: "us"
        });
        
        // Create widget container
        const widgetContainer = document.createElement('div');
        widgetContainer.className = 'tradingview-widget-container__widget';
        
        // Create copyright
        const copyright = document.createElement('div');
        copyright.className = 'tradingview-widget-copyright';
  
        
        // Add elements to container
        containerRef.current.appendChild(widgetContainer);
       
        containerRef.current.appendChild(script);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [isMobile]);

  return (
    <Box 
      sx={{ 
        width: '100%',
        maxWidth: '400px',
        mx: 'auto'
      }}
    >
      <MotionPaper
        initial={{ opacity: 0, x: isMobile ? 0 : -50, y: isMobile ? 20 : 0 }}
        animate={{ opacity: 1, x: 0, y: 0 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        elevation={4}
        sx={{ 
          borderRadius: 2,
          overflow: 'hidden',
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        {/* Header */}
        <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography 
            variant="h6" 
            component="h3"
            sx={{ 
              fontSize: { xs: '1rem', md: '1.1rem' },
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            📅 Economic Calendar
          </Typography>
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ fontSize: '0.75rem' }}
          >
            Stay updated with market events
          </Typography>
        </Box>

        {/* Widget Container */}
        <Box 
          sx={{ 
            position: 'relative',
            height: isMobile ? '350px' : '450px',
            overflow: 'hidden',
            '& .tradingview-widget-container__widget': {
              width: '100% !important',
              height: '100% !important'
            },
            '& .tradingview-widget-copyright': {
              fontSize: '12px !important',
              padding: '8px',
              textAlign: 'center',
              backgroundColor: 'rgba(0,0,0,0.1)',
              '& a': {
                color: '#2196F3 !important',
                textDecoration: 'none'
              }
            }
          }}
        >
          <div 
            className="tradingview-widget-container"
            ref={containerRef}
            style={{ 
              width: '100%', 
              height: '100%',
              position: 'relative'
            }}
          ></div>
        </Box>
      </MotionPaper>
    </Box>
  );
}; 